import Vue from 'vue'
import WOW from 'wowjs';
const wowPlugin = {
	install(Vue) {
		var wow = new WOW.WOW({
			boxClass:'wow',//动画元素css类（默认为wow）
			animateClass:'animated',// 动画css class（默认为动画）
			offset:0,// 到元素的距离触发动画时（默认值为0）
			mobile:false,//在移动设备上触发动画（默认值为true）
			live:false,// 对异步加载的内容进行操作（默认值为true）
			callback:function(box) {

			},
			scrollContainer: null // 可选的滚动容器选择器，否则使用window 
		});
		Vue.prototype.$wow = wow;
	}
};
export default wowPlugin;


// WEBPACK FOOTER //
// ./src/utils/wow.js